export default class EditInstanceRequest {
  description: string;

  active: boolean;

  startedAt: string;

  startedAtChangeConfirmed: boolean;

  constructor(obj: any = {}) {
    this.description = obj.description || '';
    this.active = obj.active;
    this.startedAt = obj.startedAt || '';
    this.startedAtChangeConfirmed = obj.startedAtChangeConfirmed || false;
  }

  public static of(obj: any = {}): EditInstanceRequest {
    return new EditInstanceRequest(obj || {});
  }

  public static ofList(obj: any[]): EditInstanceRequest[] {
    return obj.map(this.of);
  }
}
